import React,{useCallback} from 'react'
import { Form, Grid} from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useDispatch, useSelector } from 'react-redux'
import { updateInvoiceHeader, updateItemFieldValue, updateMechandiseItemById } from '../../actions/itemTabActions'
import { useEvent } from '../../hooks/useEvent'
import { SAVE_ITEM_CDS } from '../../api/apiEvents'


export const  HeaderInfo = (props)  =>{
 const dispatch=useDispatch()
  const {
    totalInvoices,totalItems,invoiceCurrency,
    totalInvoiceAmount,
    exchangeRate,
    totalGrossMass,
    totalNetMass,
    totalPackages
} = useSelector((state) => state.InvoicesReducer.invoice.invoiceHeader)


const { isLoading,saveForm }=useEvent("invoice",true)


const saveData = useCallback(async(payload)=>{
    const response = await saveForm({"invoiceHeader":{...payload}},false,SAVE_ITEM_CDS)
},[saveForm])


const saveCurrency = useCallback(async(payload)=>{
  const response = await saveForm({"invoiceHeader":{...payload}},false,SAVE_ITEM_CDS)
  if(response){
    dispatch(updateItemFieldValue(response.invoice.invoiceHeader))
  }
},[saveForm])


const saveExchangeRate = useCallback(async(payload)=>{
  const response = await saveForm({"invoiceHeader":{...payload}},false,SAVE_ITEM_CDS)
  if(response){
    dispatch(updateItemFieldValue(response.invoice.invoiceHeader))
    Object.entries(response.invoice.invoiceList).forEach(([key,value])=>{
      const header = value.header
      dispatch(updateInvoiceHeader({invoiceId:key,...header}))
    
    })
    Object.entries(response.invoice.merchandise).forEach(([key,value])=>{
      dispatch(updateMechandiseItemById(key,{convertedValue:value.convertedValue}))
    })
  
  }
  
},[saveForm])



 
const currencyDropDown = useSelector((state) => state.DropDownValues.currencyTypes)
  // const { isFormEnabled:isFormDisabled } = props
  const isFormDisabled = false

  return (
   
      <Form.Group className='float-container mb-2'>
        <Grid>
          <Grid.Row>
            <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0 b-blr-0 b-tlr-5'>
              <InputField
                isLabel={false}
                id="totalInvoices"
                type='number'
                label='Total Invoices'
                className='field-bg'
                value={totalInvoices}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalInvoices:value}))}
                onBlur={()=>saveData({"totalInvoices":totalInvoices||' '})}
              />
            </Grid.Column>

            <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0 '>
              <InputField
                isLabel={false}
                id="totalItems"
                type='number'
                label='Total Items'
                boxNumber='1/9'
                className='field-bg'
                value={totalItems}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalItems:value}))}
                onBlur={()=>saveData({"totalItems":totalItems|| ' '})}


              />
            </Grid.Column>

            <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0 '>
              <DropDown
                label='INVOICE CURRENCY'
                id="invoiceCurrency"
                boxNumber='4/10'
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={currencyDropDown}
                value={invoiceCurrency}
                disabled={isFormDisabled}
                clearable
                onChange={(value)=>{
                  dispatch(updateItemFieldValue({invoiceCurrency:value?.trim()}))
                  saveCurrency({"invoiceCurrency":value||" "})

              }}

              />
            </Grid.Column>

          

            <Grid.Column width='4' className='divFormFeild border-bottom  b-brr-0 b-trr-5'>
              <InputField
                isLabel={false}
                id="totalInvoiceAmount"
                type='text'
                boxNumber='4/11'
                label='Total Invoice Amount'
                value={totalInvoiceAmount}
                className='field-bg'
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalInvoiceAmount:value}))}
                onBlur={()=>saveData({"totalInvoiceAmount":totalInvoiceAmount||' '})}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
          <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0 b-blr-5 b-tlr-0'>
              <InputField
                isLabel={false}
                id="exchangeRate"
                type='number'
                label='Exchange Rate'
                boxNumber='4/15'
                className='field-bg'
                value={exchangeRate}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({exchangeRate:value}))}
                onBlur={()=>saveExchangeRate({"exchangeRate":exchangeRate||' '})}


              />
            </Grid.Column>
            
            <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0'>
              <InputField
                isLabel={false}
                id="totalGrossMass"
                type='number'
                label='Total Gross Mass'
                boxNumber='6/5'
                className='field-bg'
                value={totalGrossMass}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalGrossMass:value}))}
                onBlur={()=>saveData({"totalGrossMass":totalGrossMass||' '})}


              />
            </Grid.Column>
            <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0'>
              <InputField
                isLabel={false}
                id="totalNetMass"
                type='number'
                label='Total Net Mass'
                boxNumber='6/1'
                className={'field-bg'}
                value={totalNetMass}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalNetMass:value}))}
                onBlur={()=>saveData({"totalNetMass":totalNetMass || ' '})}

                

              />
            </Grid.Column>
            <Grid.Column width='4' className='divFormFeild border-bottom  b-brr-5 b-trr-0'>
              <InputField
                isLabel={false}
                id="totalPackages"
                type='number'
                label='Total Pkgs'
                boxNumber='6/18'
                className='field-bg'
                value={totalPackages}
                clearInput={false}
                disabled={isFormDisabled}
                onChange={(value)=>dispatch(updateItemFieldValue({totalPackages:value}))}
                onBlur={()=>saveData({"totalPackages":totalPackages||' '})}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Group>

      
  )
}

export default React.memo(HeaderInfo)
